import { formatDate } from "./formatters";

// GridTable's getRowId defaults to `(r) => r.id` — API rows don't have one natively.
export function withId(rows, idField) {
  return (rows || []).map((r) => ({ ...r, id: r[idField] }));
}

// "Finding" = Question (the actual finding/question text), not SubCategory.
export const reportItemDrillColumns = [
  { field: "assetType", headerName: "Asset Type", width: 130 },
  { field: "assetName", headerName: "Asset Name", flex: 1, minWidth: 125 },
  { field: "question", headerName: "Finding", flex: 1, minWidth: 125 },
  { field: "inspectorName", headerName: "Inspector", flex: 1, minWidth: 110 },
  { field: "dateOfEntry", headerName: "Date", width: 110, valueFormatter: ({ value }) => formatDate(value) },
  { field: "formTitle", headerName: "Form", flex: 1, minWidth: 120 },
  { field: "status", headerName: "Status", width: 100 },
];

export const correctiveItemDrillColumns = [
  { field: "projectName", headerName: "Project", flex: 1, minWidth: 125 },
  { field: "issue", headerName: "Issue", flex: 1, minWidth: 125 },
  { field: "inspectorName", headerName: "Inspector", flex: 1, minWidth: 110 },
  { field: "dateOfCorrective", headerName: "Date", width: 110, valueFormatter: ({ value }) => formatDate(value) },
  { field: "status", headerName: "Status", width: 100 },
];
